export default "__VITE_ASSET__C5G9mD18__"